import React from "react";
import {
  Esic2Icon,
  FacebookIcon,
  InstagramIcon,
  Plus18Icon,
  TwitterIcon,
} from "@picklebet/ui";

import * as styles from "./Footer.module.scss";

const SocialIcons = () => (
  <div className={styles.social}>
    <a
      href="https://www.facebook.com/picklebet"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FacebookIcon />
    </a>

    <a
      href="https://twitter.com/picklebet"
      target="_blank"
      rel="noopener noreferrer"
    >
      <TwitterIcon />
    </a>

    <a
      href="https://www.instagram.com/picklebet/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <InstagramIcon />
    </a>

    <Plus18Icon />

    <a href="https://esic.gg/" target="_blank" rel="noopener noreferrer">
      <Esic2Icon />
    </a>
  </div>
);

export { SocialIcons };
